import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Avatar, Image, Tag, Divider, message } from "antd";
import VideoPlayer from "react-video-js-player";

import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";
import { CopyToClipboard } from "react-copy-to-clipboard";
const { Meta } = Card;

class CulturalcreativeWorksShowModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  static propTypes = {
    objectCollection: PropTypes.object,
  };

  state = {
    copyWebUrl: null,
    worksFileUrl: "https://ccworksap.tut.edu.tw/",
    isUpdate: true,
    isInsert: false,
    item: {
      Uid: "",
      AcademicYear: getNowAcademicYear(new Date()),
      AcademicSemester: getNowAcademicSemester(new Date()),

      ObjectCollectionNid: 0,
      ObjectCollectionName: "",
      ObjectCollectionDescription: "",

      ObjectOriginalName: "",
      ObjectOriginalFilePath: "",

      ObjectVideoName: "",
      ObjectVideoFilePath: "",

      ObjectImageName: "",
      ObjectImageFilePAth: "",

      PowerOfAttorneyFilePath: "",

      CreativeCommonsLicense: "COPYRIGHT",
      IsOriginality: "YES",
      IsPublic: "YES",
      ObjectType: "2D",

      ObjectOwner: "",
      ObjectOwnerName: "",

      ReferrerId: "",
      ReferrerName: "",

      CategoryCode: "0",
      CategoryName: "未分類",

      KeywordA: "",
      KeywordB: "",
      KeywordC: "",
      RecordCreateOperator: "",
    },
  };

  UNSAFE_componentWillMount() {
    this.init();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  // 數據配置設定 //////////////////////////////////////////////

  init = () => {
    // console.log(this.props.objectCollection)
    if (this.props.objectCollection) {
      const worksUIUrl = "https://ccworksui.tut.edu.tw/";
      const item = this.props.objectCollection;
      const copyWebUrl = worksUIUrl + "object?id=" + item.Uid;
      this.setState({ item, copyWebUrl });
    }
  };

  style_switch_text_tag(name, value) {
    let ans = "其他";

    switch (name) {
      case "LICENSE":
        switch (value) {
          case "BOTH":
            ans = "無限制";
            break;
          case "BYNCSA":
            ans = "非商業性分享";
            break;
          case "COPYRIGHT":
            ans = "版權所有";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      case "TYPE":
        switch (value) {
          case "OTHER":
            ans = "其它";
            break;
          case "2D":
            ans = "平面";
            break;
          case "3D":
            ans = "立體";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      case "ORIGINAL":
        switch (value) {
          case "BOTH":
            ans = "其它";
            break;
          case "NO":
            ans = "非原創";
            break;
          case "YES":
            ans = "原創";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      case "PUBLIC":
        switch (value) {
          case "NO":
            ans = "關閉瀏覽";
            break;
          case "YES":
            ans = "開放瀏覽";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      default:
        // OTHER
        break;
    }
  }

  style_switch_color_tag(name, value) {
    let ans = "#87d068";
    switch (name) {
      case "LICENSE":
        switch (value) {
          case "BOTH":
            ans = "olive";
            break;
          case "BYNCSA":
            ans = "sienna";
            break;
          case "COPYRIGHT":
            ans = "goldenRod";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      case "TYPE":
        switch (value) {
          case "OTHER":
            ans = "magenta";
            break;
          case "2D":
            ans = "darkSlateBlue";
            break;
          case "3D":
            ans = "indigo";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      case "ORIGINAL":
        switch (value) {
          case "BOTH":
            ans = "plum";
            break;
          case "NO":
            ans = "steelBlue";
            break;
          case "YES":
            ans = "darkOrange";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      case "PUBLIC":
        switch (value) {
          case "NO":
            ans = "dimGray";
            break;
          case "YES":
            ans = "green";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      default:
        // OTHER
        break;
    }
  }
  // 操作互動處理 //////////////////////////////////////////////
  handleCopy = () => {
    message.info("複製網址成功");
  };
  //////////////////////////////////////////////////////////

  render() {
    const { copyWebUrl, worksFileUrl } = this.state;
    const {
      IsPublic,
      ObjectType,
      IsOriginality,
      CategoryName,
      ObjectCollectionName,
      PowerOfAttorneyFilePath,
      ObjectOriginalFilePath,
      ObjectImageFilePath,
      ObjectVideoFilePath,
      CreativeCommonsLicense,
      ObjectCollectionDescription,
      KeywordA,
      KeywordB,
      KeywordC,
      TotalSeenTotal,
      TotalLikeTotal,
      TotalTagTotal,
      TotalDiscussTotal,
    } = this.props.objectCollection;
    const title = (
      <>
        <Divider orientation="right">
          <Tag color="#f50">
            <i className="fas fa-desktop"></i> {CategoryName}
          </Tag>
        </Divider>
        名稱：{ObjectCollectionName}
        <div>
          {" "}
          標籤：
          {KeywordA === "" ? (
            ""
          ) : (
            <Tag color="magenta">
              <i className="fas fa-tag"></i> {KeywordA}
            </Tag>
          )}
          {KeywordB === "" ? (
            ""
          ) : (
            <Tag color="magenta">
              <i className="fas fa-tag"></i> {KeywordB}
            </Tag>
          )}
          {KeywordC === "" ? (
            ""
          ) : (
            <Tag color="magenta">
              <i className="fas fa-tag"></i> {KeywordC}
            </Tag>
          )}
        </div>
      </>
    );
    //console.log(ObjectImageFilePath);
    const pngfile =
      ObjectImageFilePath === ""
        ? "https://www.salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png"
        : worksFileUrl + ObjectImageFilePath;
    const mp4file = worksFileUrl + ObjectVideoFilePath;
    const sourcefile = worksFileUrl + ObjectOriginalFilePath;
    const pdffile = worksFileUrl + PowerOfAttorneyFilePath;
    const avatarfile =
      CreativeCommonsLicense === "COPYRIGHT" ? (
        <Avatar
          shape="square"
          size={64}
          src="https://www.inventionpathways.com.au/wp-content/uploads/2017/09/copyright-300x300.png"
        />
      ) : (
        <Avatar
          size={64}
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/CC-BY-NC-SA.svg/512px-CC-BY-NC-SA.svg.png"
        />
      );

    return (
      <div>
        <Card
          style={{ width: 470 }}
          cover={
            ObjectVideoFilePath === "" ? (
              <Image
                src={pngfile}
                fallback="data:image/png;base64,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"
              />
            ) : (
              <VideoPlayer
                controls={true}
                src={mp4file}
                poster={pngfile}
                width="470"
              />
            )
          }
          actions={[
            <span>
              <i className="far fa-eye"></i> {TotalSeenTotal}
            </span>,
            <span>
              <i className="far fa-heart"></i> {TotalLikeTotal}
            </span>,
            <span>
              <i className="fas fa-tag"></i> {TotalTagTotal}
            </span>,
            <span>
              <i className="far fa-comment"></i> {TotalDiscussTotal}
            </span>,
          ]}
        >
          <Meta
            avatar={avatarfile}
            title={title}
            description={
              <span
                dangerouslySetInnerHTML={{
                  __html: ObjectCollectionDescription,
                }}
              />
            }
          />
          <p>
            <Tag color="default">
              {this.style_switch_text_tag("PUBLIC", IsPublic)}
            </Tag>
            <span>/ </span>
            <Tag color="default">
              {this.style_switch_text_tag("TYPE", ObjectType)}
            </Tag>
            <span>/ </span>
            <Tag color="default">
              {this.style_switch_text_tag("ORIGINAL", IsOriginality)}
            </Tag>
            <span>/ </span>
            <Tag color="default">
              {this.style_switch_text_tag("LICENSE", CreativeCommonsLicense)}
            </Tag>
          </p>
          <div
            className="btn-group d-flex"
            role="group"
            aria-label="Basic example"
          >
            <a
              href={pdffile}
              target="_blank"
              rel="noreferrer"
              className="btn btn-secondary"
              download="授權書"
            >
              <i className="fas fa-file-signature"></i> 授權書
            </a>
            <a
              href={sourcefile}
              target="_blank"
              rel="noreferrer"
              className="btn btn-secondary"
              download="原始檔"
            >
              <i className="fas fa-file-invoice"></i> 原始檔
            </a>
          </div>
          <div>
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span className="input-group-text">作品網址</span>
              </div>
              <input
                value={copyWebUrl}
                readOnly
                type="text"
                className="form-control"
                aria-label="Amount (to the nearest dollar)"
              />
              <div className="input-group-append">
                <CopyToClipboard text={copyWebUrl} onCopy={this.handleCopy}>
                  <button className="form-control" style={{ color: "red" }}>
                    <i className="fa fa-copy"></i> 複製網址
                  </button>
                </CopyToClipboard>
              </div>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(CulturalcreativeWorksShowModal);
